"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOSAVE_TIMEOUT_INTERVAL = void 0;
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styles_1 = require("@material-ui/core/styles");
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
// import { Prompt } from 'react-router';
var ProgramStore = __importStar(require("../../../app/store/ProgramStore"));
var components_1 = require("../../../youwell-common/components");
var taskContentUtils_1 = require("../../../common/taskContentUtils");
var taskUtils_1 = require("../../../common/taskUtils");
var responseUtils_1 = require("../../../youwell-common/responseUtils");
var WorkSheet_1 = __importDefault(require("./WorkSheet"));
var store_1 = require("../../../app/store");
var useStyles = (0, styles_1.makeStyles)(({
    root: {
        // Flex-display with wrap needed for card-layout on page
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        '@media print': {
            display: 'block',
        },
    },
}), { name: 'MyTaskContent' });
exports.AUTOSAVE_TIMEOUT_INTERVAL = 1000; // miliseconds
var MyTaskContent = function (_a) {
    var _b;
    var task = _a.task, patientProgramElementId = _a.patientProgramElementId, className = _a.className, forwardedRef = _a.forwardedRef;
    var classes = useStyles();
    var dispatch = (0, react_redux_1.useDispatch)();
    var saveTimer = React.useRef();
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    var currentProgram = (0, store_1.useYouwellSelector)(function (state) { return state.programStore.currentProgram; });
    var allTaskResponses = (0, store_1.useYouwellSelector)(function (state) { return state.programStore.currentProgramTaskResponses; });
    var _c = React.useState(null), changeId = _c[0], setChangeId = _c[1];
    var responsesForCurrentTask = task.patientProgramElementId ? (_b = allTaskResponses === null || allTaskResponses === void 0 ? void 0 : allTaskResponses[task.patientProgramElementId]) === null || _b === void 0 ? void 0 : _b[task.id] : null;
    var formId = responsesForCurrentTask === null || responsesForCurrentTask === void 0 ? void 0 : responsesForCurrentTask.formId;
    var updateResponse = function (responses) {
        var responseData = {
            taskId: task.id,
            taskVersion: task.version,
            patientProgramElementId: patientProgramElementId,
            formId: formId,
            responses: responses,
        };
        setChangeId(Date.now());
        dispatch(ProgramStore.actionCreators.updateResponse(responseData));
    };
    var saveResponses = React.useCallback(function (taskResponses, callback, background, submitForm) {
        var responseData = (changeId || submitForm) && (0, responseUtils_1.getUpdatedResponsesForTask)(taskResponses, patientProgramElementId, task.id, task.version, formId, submitForm);
        if (responseData) {
            dispatch(ProgramStore.actionCreators.saveResponse(responseData, {
                background: background,
                callback: function () {
                    setChangeId(function (prevId) { return (prevId === changeId ? null : prevId); });
                    if (callback) {
                        callback();
                    }
                },
            }));
        }
        else if (callback) {
            callback();
        }
    }, [changeId, patientProgramElementId, task.id, task.version, formId, dispatch]);
    var saveChanges = function (callback, submitForm) {
        if (responsesForCurrentTask || submitForm) {
            clearTimeout(saveTimer.current);
            saveResponses(responsesForCurrentTask, callback, false, (submitForm && !(responsesForCurrentTask === null || responsesForCurrentTask === void 0 ? void 0 : responsesForCurrentTask.submitted)));
        }
        else if (callback) {
            callback();
        }
    };
    React.useEffect(function () {
        if (responsesForCurrentTask && changeId) {
            if (saveTimer.current) {
                clearTimeout(saveTimer.current);
            }
            saveTimer.current = setTimeout(function () {
                saveResponses(responsesForCurrentTask, null, true);
            }, exports.AUTOSAVE_TIMEOUT_INTERVAL);
        }
    }, [changeId, responsesForCurrentTask, saveResponses, task.id]);
    var getLinkUrl = function (link) { return (0, taskUtils_1.getProgramContentLink)(link, currentProgram); };
    var getProgramItem = function (id) { return (0, taskContentUtils_1.getItemFromPatientProgram)(currentProgram, id); };
    return (React.createElement(React.Fragment, null,
        React.createElement(components_1.TaskContent, { ref: forwardedRef, className: (0, classnames_1.default)(classes.root, className), TaskFormProps: {
                disabled: !!(responsesForCurrentTask === null || responsesForCurrentTask === void 0 ? void 0 : responsesForCurrentTask.submitted),
                readOnly: !(currentProgram === null || currentProgram === void 0 ? void 0 : currentProgram.isActiveProgram),
            }, LinkElementProps: {
                getLinkUrl: getLinkUrl,
                autoplayVideos: clientConfig.appSetup.features.autoplayVideos,
            }, task: task, taskResponses: responsesForCurrentTask, getProgramItem: getProgramItem, getSpecificTaskResponses: (0, responseUtils_1.getSpecificTaskResponses)(allTaskResponses, responsesForCurrentTask), onResponse: updateResponse, onSaveChanges: saveChanges, changeId: changeId }),
        task.isWorkSheet && (React.createElement(WorkSheet_1.default, { task: task, currentForm: responsesForCurrentTask, taskContentRef: forwardedRef }))));
};
MyTaskContent.propTypes = {
    task: prop_types_1.default.object.isRequired,
    patientProgramElementId: prop_types_1.default.string.isRequired,
    className: prop_types_1.default.string,
    forwardedRef: prop_types_1.default.object,
};
MyTaskContent.defaultProps = {
    className: null,
    forwardedRef: null,
};
var WithRef = React.forwardRef(function (props, ref) { return React.createElement(MyTaskContent, __assign({}, props, { forwardedRef: ref })); });
exports.default = WithRef;
